export default {
  quizsets: [],
  quizset: {},
  name: '',
  map: '',
  mapChanged: false
}
